import { resolveActionUrl, resolveI18nText, resolveTextVariables, } from "./templating.js";
export function findElementByKey(step, key) {
    var _a, _b;
    if (!step) {
        return undefined;
    }
    if (((_a = step.ctaButton) === null || _a === void 0 ? void 0 : _a.key) === key) {
        return step.ctaButton;
    }
    return (_b = step.links) === null || _b === void 0 ? void 0 : _b.find((l) => l.key === key);
}
export function buildDialogPayload(step, logoUrl, locale, urlVars, textVars, allowedUrlHosts) {
    function resolveText(key) {
        return resolveTextVariables(resolveI18nText(step.i18n, key, locale), textVars);
    }
    const payload = {
        title: resolveText(step.title.key),
        body: step.body.map((entry) => ({
            text: resolveText(entry.key),
            style: "paragraph",
        })),
        logoUrl,
        touchPointStep: step.id,
        showCloseButton: step.showCloseButton !== false,
    };
    if (step.ctaButton) {
        payload.ctaButton = {
            text: resolveText(step.ctaButton.key),
            key: step.ctaButton.key,
            url: resolveActionUrl(step.ctaButton.action, urlVars, allowedUrlHosts),
        };
    }
    if (typeof step.autoDismissMs === "number") {
        payload.autoDismissMs = step.autoDismissMs;
    }
    if (step.links && step.links.length > 0) {
        payload.links = step.links.map((link) => {
            const url = resolveActionUrl(link.action, urlVars, allowedUrlHosts);
            const dialogLink = {
                text: resolveText(link.key),
                key: link.key,
            };
            if (url) {
                dialogLink.url = url;
            }
            return dialogLink;
        });
    }
    return payload;
}
